export default "__VITE_ASSET__D453ABiS__"